import React from "react";
import { makeStyles, withStyles, LinearProgress } from "@material-ui/core";

const ProgressBar = (props) => {
  const ColorLinearProgress = withStyles({
    root: {
      width: "50vw",
    },
  })(LinearProgress);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    margin: {
      margin: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ColorLinearProgress
        className={classes.margin}
        variant="determinate"
        color= "primary"
        value={props.value}
      />
    </div>
  );
};

export default ProgressBar;